import React from 'react';
import { Table } from 'reactstrap';
import moment from 'moment-timezone';
import { FaEdit } from 'react-icons/fa';
import { BsPlusSquareFill } from 'react-icons/bs';
import { IconContext } from 'react-icons/lib';
import { Button } from 'reactstrap';
const OrderPayment = props => {
  return (
    <>
      <div className="text-right mb-3">
        <div className="ps-btn-group">
          <Button color="link" onClick={props.paymentModal()}>
            <IconContext.Provider value={{ color: '#2a2c6b' }}>
              <BsPlusSquareFill size={25} />
            </IconContext.Provider>
          </Button>
        </div>
      </div>
      <Table responsive hover className="ps-table tb-col-6">
        <thead>
          <tr>
            <th>Payment Type</th>
            <th>Amount</th>
            <th>User</th>
            <th>Remark</th>
            <th>Reference</th>
            <th>Datetime</th>
          </tr>
        </thead>
        <tbody>
          {props.state.payment_items.length < 1 && (
            <tr>
              <td colSpan="6">
                <div className="ps-empty-data">
                  <div className="empty-content">
                    <h4>No data to show</h4>
                  </div>
                </div>
              </td>
            </tr>
          )}

          {props.state.payment_items.length > 0 &&
            props.state.payment_items.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item.payment_type}</td>
                  <td>{item.amount}</td>
                  <td>{item.user_id}</td>
                  <td>
                    {item.data}{' '}
                    <Button
                      color="link"
                      style={{ padding: '2px 0px 5px 5px' }}
                      onClick={props.dataModal(item.payment_id, item.data)}
                    >
                      <IconContext.Provider value={{ color: '#2a2c6b' }}>
                        <FaEdit size={16} />
                      </IconContext.Provider>
                    </Button>
                  </td>
                  <td>
                    {item.reference}{' '}
                    <Button
                      color="link"
                      style={{ padding: '2px 0px 5px 5px' }}
                      onClick={props.referenceModal(
                        item.payment_id,
                        item.reference,
                      )}
                    >
                      <IconContext.Provider value={{ color: '#2a2c6b' }}>
                        <FaEdit size={16} />
                      </IconContext.Provider>
                    </Button>
                  </td>
                  <td>
                    {moment(item.datetime)
                      .tz('Asia/Singapore')
                      .format('YYYY-MM-DD hh:mm:ss A')}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </>
  );
};

export default OrderPayment;
